import { useEffect, useRef } from "react";
import useUuid from "../../../hooks/uuid-hook";
import "./tristate-checkbox.scss";

export interface ITristateCheckboxProps {
    label: string;
    value: TRISTATE_CHECKBOX_VALUES;
    size?: CHECKBOX_SIZES;
    onChange?(checked: TRISTATE_CHECKBOX_VALUES): void;
    disabled?: boolean;
}

export enum CHECKBOX_SIZES {
    SMALL = 'small',
    MEDIUM = 'medium',
}

export enum TRISTATE_CHECKBOX_VALUES {
    CHECKED = 'checked',
    UNCHECKED = 'unchecked',
    PARTIALLY_CHECKED = 'partially checked',
}

export const TristateCheckbox: React.FC<ITristateCheckboxProps> = ({
    label,
    onChange = () => { },
    size = CHECKBOX_SIZES.MEDIUM,
    disabled = false,
    value = TRISTATE_CHECKBOX_VALUES.UNCHECKED,
}) => {
    const elemId = useUuid();
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled && onChange) {
            if (e.target.checked) {
                onChange(TRISTATE_CHECKBOX_VALUES.CHECKED);
            }  
            else {
                onChange(TRISTATE_CHECKBOX_VALUES.UNCHECKED);
            }
        }
    }
    const cRef = useRef(null);

    useEffect(() => {
        const checkbox = cRef.current as unknown as HTMLInputElement;
        if (checkbox) {
            if (value === TRISTATE_CHECKBOX_VALUES.PARTIALLY_CHECKED) {
                checkbox.classList.add('indeterminate');
            }
            else {
                checkbox.classList.remove('indeterminate');
            }
        }
        
    },[elemId, value]);


    return (
        <div className={`checkbox-block${disabled ? ' disabled' : ''} size-${size}`}>
            <label htmlFor={elemId}>
                <input type="checkbox" disabled={disabled} id={elemId} checked={value !== TRISTATE_CHECKBOX_VALUES.UNCHECKED} onChange={handleChange} ref={cRef}/>
                <span className="checkbox"></span>{label}
            </label>
        </div>
    );
}
